import { IPhoneDetails } from '../_models/businessInterface'
import { OtpData } from '../_models/otpInterface'
import { get, post } from '../_services/apiServices'
const getOtp = async () => {
  const response = await get('/phones/verification')
  return response
}
const verifyOtp = async (otpData: OtpData) => {
  const response = await post('/phones/verification', otpData)
  return response
}
// eslint-disable-next-line camelcase
const enableWtsp = async (wtspData: { receive_whatsapp: boolean }) => {
  const response = await post('/phones/whatsapp-notification/update', wtspData)
  return response
}
const enableSMS = async (smsData: { receive_sms: boolean }) => {
  const response = await post('/phones/sms-notification/update', smsData)
  return response
}
const resendOtp = async () => {
  const response = await get('/phones/verification/resend')
  return response
}
const wrongNumber = async (params: IPhoneDetails) => {
  const response = await post('/phones/change-number', params)
  return response
}

const otpServices = {
  getOtp,
  verifyOtp,
  enableWtsp,
  enableSMS,
  resendOtp,
  wrongNumber,
}
export default otpServices
